import { useEffect } from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { theme } from "./theme";
import "./styles/index.scss";
import Routing from "./Routes";
import { requestPermission, getMessage } from "./utils/firebase";

function App() {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration) => {
          console.log("ServiceWorker registration successful with scope: ", registration.scope);
        })
        .catch((err) => {
          console.error("ServiceWorker registration failed: ", err);
        });
    }

    const FCMTOKEN = localStorage.getItem("fcmToken");
    const token = localStorage.getItem("@secure.s.TOKEN");
    if (token) {
      if (!FCMTOKEN) {
        requestPermission();
      }
    }

    const unsubscribe = getMessage();
    return () => unsubscribe();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routing />
    </ThemeProvider>
  );
}

export default App;
